import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoResultsAddCompany = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 241,
	height: 220,
	viewBox: "0 30 241 160",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("rect", {
			x: 34.5,
			y: 94.0117,
			width: 132,
			height: 70,
			fill: "#63688B"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 16,
			y: 62.6211,
			width: 61.465,
			height: 24.7567,
			fill: "#63688B"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 22.8242,
			y: 72.0117,
			width: 6.82944,
			height: 6.82944,
			rx: 3.41472,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 31.3672,
			y: 72.0117,
			width: 40.9767,
			height: 6.82944,
			rx: 3.41472,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_4496_12038",
			style: { maskType: "alpha" },
			maskUnits: "userSpaceOnUse",
			x: 133,
			y: 85,
			width: 46,
			height: 53,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M147.89 130.063C140.134 123.788 134.529 111.28 133.805 100.102L137.774 85.6719L176.636 87.1141C177.813 102.139 179.462 134.638 176.636 136.657C173.103 139.181 157.799 138.08 147.89 130.063Z",
				fill: "#D9D9D9"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask0_4496_12038)",
			children: /* @__PURE__ */ _jsx("rect", {
				x: 46.7578,
				y: 89.2773,
				width: 127.989,
				height: 58.415,
				fill: "#9499B6"
			})
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 48.6445,
			y: 111.785,
			width: 47.5503,
			height: 6.60421,
			rx: 3.30211,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 48.8633,
			y: 124.09,
			width: 81.9533,
			height: 6.4026,
			rx: 3.2013,
			fill: "white"
		}),
		/* @__PURE__ */ _jsx("ellipse", {
			cx: 100.821,
			cy: 54.4907,
			rx: 3.32088,
			ry: 2.49066,
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M77.0214 37.573C77.6785 36.4347 79.3215 36.4347 79.9787 37.573L81.4247 40.0779C81.5885 40.3617 81.8305 40.5923 82.1217 40.7423L84.5522 41.9938C85.7865 42.6294 85.7865 44.3941 84.5522 45.0297L82.1217 46.2812C81.8305 46.4312 81.5885 46.6618 81.4247 46.9455L79.9786 49.4504C79.3215 50.5887 77.6785 50.5887 77.0214 49.4504L75.5753 46.9455C75.4115 46.6618 75.1695 46.4312 74.8783 46.2812L72.4478 45.0297C71.2135 44.3941 71.2135 42.6294 72.4478 41.9938L74.8783 40.7423C75.1695 40.5923 75.4115 40.3617 75.5753 40.0779L77.0214 37.573Z",
			fill: "#F385FF"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M191.305 134.711L196.445 144.033",
			stroke: "#C9D8FC",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 202.648,
			y: 140.605,
			width: 46.129,
			height: 14.1935,
			rx: 3.54838,
			transform: "rotate(61.1281 202.648 140.605)",
			fill: "#C9D8FC"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M206.343 81.7097C216.685 100.466 209.866 124.061 191.102 134.407C172.337 144.754 148.745 137.927 138.403 119.171C128.061 100.415 134.88 76.8203 153.644 66.4738C172.409 56.1272 196.001 62.9537 206.343 81.7097Z",
			fill: "white",
			fillOpacity: .5,
			stroke: "#C9D8FC",
			strokeWidth: 3
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M195.542 87.6673C202.597 100.462 197.944 116.554 185.149 123.609",
			stroke: "#C9D8FC",
			strokeWidth: 3,
			strokeLinecap: "round"
		})
	]
});
export default SvgNoResultsAddCompany;
